import React from "react";
import "./style.scss";
import ContactCareManager from "../CareManagerColumn/ContactCareManager";
import dayjs from "dayjs";
import discuter from "../../../../assets/icons/discuter.svg";
import info from "../../../../assets/icons/info.svg";
import PropTypes from "prop-types";
import {useHistory} from "react-router-dom";
import FreeQuestionChatBot from "../../../Chat/ChatBotFreeQuestion/FreeQuestionChatBot/FreeQuestionChatBot";
import imgIntroMobile from "../../../../assets/img/offerModal/offre-3.png";
import "../../styles/style-mobile.scss";
import Banniere from "../../../Banniere/Banniere";
import useWindowDimensions from "../../../../hook/useWindowDimension";

const DashboardQuestions = ({
                                questionsAndAnswers,
                                setShowOfferModal,
                                setDisplayQuestions,
                                isSouscription,
                                idExt,
                                setOpenFreeQuestionChatBot,
                                openFreeQuestionChatBot,
                                dataUser
                            }) => {
    const history = useHistory();
    const {width} = useWindowDimensions();
    const handlePlanDemand = () => {
        if (idExt === "B2C" && isSouscription === undefined) {
            null;
        } else if (idExt === "B2C" && !isSouscription) {
            // Si le user est un client B2C et qu'il n'a pas de souscriptions
            // on ouvre la modal des offres payantes
            setShowOfferModal(true);
        } else if (idExt === "BPCE-B2C") {
            setShowOfferModal(true);
        } else if (idExt === "B2C" && isSouscription) {
            // Si c'est un client B2C et qu'il a une souscriptions
            // on le redirige vers le bot de demande de rendez-vous
            history.push("/conversation");
        } else if (idExt !== "B2C") {
            // Si le user à un idExt différent de B2C, c'est qu'il a entré un code d'activation
            // et qu'il est rattaché à une entreprise (client B2B)
            history.push("/conversation");
        } else {
            setShowOfferModal(true);
        }
    };

    return (
        openFreeQuestionChatBot
            ? <FreeQuestionChatBot openFreeQuestionChatBot={openFreeQuestionChatBot}/>
            : <main className={"vosQuestions"}>
                <div className={"vosQuestions-header"}>
                    {width > 599 && <Banniere dataUser={dataUser} navItem={"none"}/>}
                    <img src={imgIntroMobile}/>
                    <h2 className={"titleMobile1"}>
                        Vos<span className={"titleMobile2 nauticus"}> questions</span>
                    </h2>
                </div>

                <div className={"vosQuestions-container"}>
                    <ContactCareManager
                        id={"contactCareManager_home"}
                        setShowOfferModal={setShowOfferModal}
                        setDisplayQuestions={setDisplayQuestions}
                        isSouscription={isSouscription}
                        idExt={idExt}
                        setOpenFreeQuestionChatBot={setOpenFreeQuestionChatBot}
                        openFreeQuestionChatBot={openFreeQuestionChatBot}
                    />


                    {questionsAndAnswers &&
                        questionsAndAnswers.map((q, index) => (
                            <div
                                key={q.id}
                                className={"vosQuestions-container-card"}
                                onClick={() => history.push(`/question/${q.id}`)}
                            >
                                <h3>Votre question {index + 1}</h3>
                                <p>{dayjs(q.date).format("DD/MM/YYYY")}</p>
                                {q.reponses &&
                                    q.reponses.map((r) => {
                                        if (r.state == 0) return (<p className={"vosQuestions-container-card-message"}>
                                            1 nouveau message</p>); else return null;
                                    })}
                                <button className={"vosQuestions-container-card-button"}>
                                    <img src={discuter} alt={"voir la réponse"}/>
                                    Voir la réponse
                                </button>
                            </div>
                        ))
                    }
                </div>

                <div className={"barre-info"}>
                    <img className={"info-icon	c"} src={info} alt={"icône info"}/>
                    <div className={"barre-info-content"}>
                        <h1 className="barre-info-content-title">
                            Vous souhaitez aller plus loin ?
                        </h1>
                        <p>
                            {
                                "Lorsque l'organisation des soins de votre proche fragilisé par l'âge, la maladie, ou le handicap vous submerge, nos Care Managers sont à vos côtés pour mettre en place les meilleures solutions."
                            }
                        </p>
                        <button onClick={handlePlanDemand}>{"Ça m'intéresse, en savoir plus →"}</button>
                        {/*{showOfferModal && <OfferModal/>}*/}
                    </div>
                </div>
            </main>
    );
};
DashboardQuestions.propTypes = {
    questionsAndAnswers: PropTypes.array,
    setShowOfferModal: PropTypes.func,
    setDisplayQuestions: PropTypes.func,
    isSouscription: PropTypes.func,
    idExt: PropTypes.string,
    setOpenFreeQuestionChatBot: PropTypes.func,
    openFreeQuestionChatBot: PropTypes.bool,
    dataUser: PropTypes.object
};
export default DashboardQuestions;